import React, { ReactNode } from "react";
import { Drawer, DrawerProps, Button } from "@mui/material";
import ClearRoundedIcon from "@mui/icons-material/ClearRounded";
import clsx from "clsx";
import { useStyles } from "./Popin.styles";

export type PopinProps = {
  children?: ReactNode;
  openPopin: boolean;
  toggleDrawer: any;
  minWidth?: number | string;
  containerClassName?: string;
  customCloseAction?: any;
  scrollTop?: any;
  showFirst?: boolean;
};

export function Popin({
  children,
  openPopin,
  toggleDrawer,
  minWidth = 566.2,
  containerClassName = "",
  customCloseAction,
  scrollTop = true,
  showFirst = false,
  ...props
}: PopinProps & DrawerProps) {
  const classes = useStyles();
  const ref = React.useRef<HTMLDivElement>(null);
  const refContainer = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    setTimeout(() => {
      if (ref.current && ref.current.click) {
        ref.current.click();
        ref.current.scrollTo?.(0, 0);
      }
    }, 200);
  }, []);

  React.useEffect(() => {
    setTimeout(() => {
      if (refContainer.current?.click) {
        refContainer.current?.scrollTo?.(0, 0);
      }
    }, 200);
  }, [scrollTop]);

  return (
    <Drawer
      ref={ref}
      anchor="right"
      open={openPopin}
      // onClose={() => toggleDrawer(false)}
      className={classes.popinContainer}
      style={{
        zIndex: showFirst === true ? "9992 !important" : "9991 !important",
      }}
      {...props}
    >
      <Button
        className={classes.iconClose}
        onClick={(e) => {
          if (customCloseAction) {
            customCloseAction();
            toggleDrawer(false);
          } else {
            toggleDrawer(false);
            e.preventDefault();
          }
        }}
      >
        <ClearRoundedIcon style={{ color: "black" }} />
      </Button>
      <div
        className={clsx(classes.popin, containerClassName)}
        style={{ minWidth }}
        ref={refContainer}
      >
        {children}
      </div>
    </Drawer>
  );
}

export default Popin;
